import { FC, lazy } from 'react';
import { Successful } from 'src/hooks/use-axios';
import { useTitle } from 'src/hooks/use-title';
import { CurrentShipperUserRequest } from 'src/pages/settings/notifications/use-current-shipper-user';
import { NotificationSettingsRequest } from 'src/pages/settings/notifications/use-notification-settings';
import { ShipperRequest } from 'src/pages/shipper-admin/details/use-shipper';

const Page = lazy(
  () => import('src/pages/settings/notifications/overview/page')
);

export const NotificationSettingsOverview: FC<{
  notificationSettings?: Successful<NotificationSettingsRequest>;
  shipperUser?: Successful<CurrentShipperUserRequest>;
  shipper?: Successful<ShipperRequest>;
}> = ({ notificationSettings, shipperUser, shipper }) => {
  useTitle('Notification Settings');
  return (
    <Page
      notificationSettings={notificationSettings}
      shipperUser={shipperUser}
      shipper={shipper}
    />
  );
};
